// extracted by mini-css-extract-plugin
export default {"label-checked":"CheckBoxFormControl_label-checked__bnBRd","disabled":"CheckBoxFormControl_disabled__BEikF"};